import { Truck, ShieldCheck, Wrench } from "lucide-react";
import { PageHero } from "@/components/sections/PageHero";
import { ServiceSection } from "@/components/sections/ServiceSection";
import { Reveal, SectionHead } from "@/components/motion/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { IMG } from "@/data/site";

const PILLARS = [
  { icon: Truck, title: "Installation", desc: "Delivery, placement and setup handled by Brewer so equipment is ready to play." },
  { icon: ShieldCheck, title: "Maintenance", desc: "Routine care that helps keep machines clean, calibrated and earning." },
  { icon: Wrench, title: "Repairs", desc: "Troubleshooting and repair when something stops working the way it should." },
];

const FAQS = [
  ["What information helps with a service request?", "The machine type, what's happening, and a photo if possible. Error messages or sounds are helpful too."],
  ["Do you service equipment you didn't install?", "Call us at (931) 473-3465 and we'll let you know how we can help with your specific machine."],
  ["What if my issue is urgent?", "Submit the form and call (931) 473-3465 so our team knows right away."],
];

export default function ServicePage() {
  return (
    <div data-testid="service-page">
      <PageHero testId="service-hero" eyebrow="Service & Support" lines={["Keep Every", "Machine Running"]} img={IMG.tech} sub="Installation, maintenance and repair support from a local team that knows commercial amusement equipment." />
      <section className="py-24 lg:py-32">
        <div className="container-x grid gap-5 md:grid-cols-3">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div className="group h-full rounded-[24px] border border-white/5 bg-ink-800 p-8 transition-[border-color] duration-500 hover:border-volt/40" data-testid={`service-pillar-${i + 1}`}>
                <p.icon className="h-6 w-6 text-volt" />
                <h3 className="mt-10 font-display text-2xl font-semibold text-white">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <ServiceSection index="01" />
      <section className="py-24 lg:py-32">
        <div className="container-x">
          <SectionHead index="02" eyebrow="FAQ" title="Service questions" />
          <Accordion type="single" collapsible className="mt-12 max-w-3xl">
            {FAQS.map(([q, a], i) => (
              <AccordionItem key={q} value={`f${i}`} className="border-white/10">
                <AccordionTrigger className="py-6 text-left font-display text-lg text-white hover:no-underline" data-testid={`faq-trigger-${i + 1}`}>{q}</AccordionTrigger>
                <AccordionContent className="text-base text-slate-400">{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
